import { TooltipRenderProps } from 'react-joyride';

import { Button } from '@deliveryhero/pd-cookbook/components/ButtonV2';
import IcArrowTailForward from '@deliveryhero/pd-cookbook/components/Icons/IcArrowTailForward';
import { Tooltip } from '@deliveryhero/pd-cookbook/components/Tooltip';
import { placementType } from '@deliveryhero/pd-cookbook/components/Tooltip/types';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';

import './styles.scss';

export const FtueTooltip = ({
  continuous,
  index,
  size,
  step,
  closeProps,
  skipProps,
  primaryProps,
  tooltipProps,
  isLastStep,
  placement = 'right',
  stepSizes = [1, 1, 3, 3],
  buttonOffset = 8,
  stepOffset = '97px'
}: TooltipRenderProps & {
  placement?: string;
  stepSizes?: number[];
  buttonOffset?: number;
  stepOffset?: string;
}) => {
  const anchorHeight =
    stepSizes[index] == 1 ? 50 : stepSizes[index] == 2 ? 68 : 86;
  const arrowHeight = 9.9;

  return (
    <div {...tooltipProps}>
      <div>
        <Tooltip
          bodyText={step.content as string}
          placement={placement as placementType}
          {...(placement == 'bottom' && { arrowAlignment: 'left' })}
        />
        <div
          style={{
            height:
              placement == 'bottom'
                ? anchorHeight + arrowHeight + buttonOffset
                : anchorHeight / 2 + buttonOffset
          }}
        ></div>
      </div>
      <div
        style={{
          position: 'fixed',
          display: 'flex',
          alignItems: 'center',
          width: 'max-content',
          ...(placement == 'bottom' && { left: '-13px' })
        }}
      >
        {continuous && !isLastStep ? (
          <>
            <div style={{ marginRight: '8px' }}>
              <Button
                key="1"
                type="button"
                data-testid="ftue-next-button"
                size="small"
                variant="secondary"
                suffix={<IcArrowTailForward />}
                className="tooltip-button"
                {...primaryProps}
              >
                Next
              </Button>
            </div>
            <div
              style={{
                position: 'absolute',
                top: '48px',
                width: '100%'
              }}
            >
              <Button
                key="2"
                type="button"
                layout="full-width-primary"
                data-testid="ftue-skip-button"
                variant="secondary-reversed"
                className="tooltip-button"
                {...skipProps}
              >
                Skip
              </Button>
            </div>
          </>
        ) : (
          <div style={{ marginRight: '36px' }}>
            <Button
              key="3"
              type="button"
              size="small"
              data-testid="ftue-done-button"
              variant="secondary"
              {...closeProps}
            >
              Done
            </Button>
          </div>
        )}
        <Typography
          type="label-lg"
          color="white"
          style={{
            marginLeft: placement == 'bottom' ? '88px' : stepOffset
          }}
        >
          {`${index + 1} of ${size}`}
        </Typography>
      </div>
    </div>
  );
};
